import { render, staticRenderFns } from "./EmailActionForm.vue?vue&type=template&id=688edb34&scoped=true"
import script from "./EmailActionForm.vue?vue&type=script&lang=js"
export * from "./EmailActionForm.vue?vue&type=script&lang=js"
import style0 from "./EmailActionForm.vue?vue&type=style&index=0&id=688edb34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688edb34",
  null
  
)

export default component.exports